import React from 'react';
import { Link as TanStackLink } from '@tanstack/react-router';

export interface NextLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: any;
  as?: string;
  replace?: boolean;
  scroll?: boolean;
  shallow?: boolean;
  passHref?: boolean;
  prefetch?: boolean;
  locale?: string | false;
  legacyBehavior?: boolean;
  children?: React.ReactNode;
}

export const Link = React.forwardRef<HTMLAnchorElement, NextLinkProps>(function Link(
  {
    href,
    as,
    replace,
    scroll,
    shallow,
    passHref,
    prefetch,
    locale,
    legacyBehavior,
    children,
    ...rest
  },
  ref,
) {
  const targetHref = typeof href === 'object' && href !== null ? (href.pathname || '/') : (href || '/');
  const isExternal = typeof targetHref === 'string' && (targetHref.startsWith('http://') || targetHref.startsWith('https://') || targetHref.startsWith('mailto:') || targetHref.startsWith('tel:'));

  if (isExternal) {
    return (
      <a ref={ref} href={targetHref} {...rest}>
        {children}
      </a>
    );
  }

  // Handle hash / anchor links on the same page
  if (typeof targetHref === 'string' && targetHref.startsWith('#')) {
    return (
      <a ref={ref} href={targetHref} {...rest}>
        {children}
      </a>
    );
  }

  // In SSR / prerender environment without browser window or TanStack router context, render native <a>
  if (typeof window === 'undefined') {
    return (
      <a ref={ref} href={targetHref} {...rest}>
        {children}
      </a>
    );
  }

  return (
    <TanStackLink
      ref={ref}
      to={targetHref as any}
      replace={replace}
      {...(rest as any)}
    >
      {children}
    </TanStackLink>
  );
});

export default Link;
